namespace Matrix.Data {
    export interface PartyRow {
        PartyCode?: string;
        Name?: string;
        ShortName?: string;
        CountryOfDomicileCode?: string;
        CountryOfIncorporationCode?: string;
        CountryOfRiskCode?: string;
        PartyLegalName?: string;
        PartyWebAddress?: string;
        PartyFaxNumber?: string;
        PartyTelNumber?: string;
        PreviousPartyNames?: string;
        AlternativePartyName?: string;
        IsPrivateCompany?: boolean;
        SpLtRating?: string;
        MoodysLtRating?: string;
        FitchLtRating?: string;
        InternalLtRating?: string;
        SpStRating?: string;
        MoodysStRating?: string;
        FitchStRating?: string;
        InternalStRating?: string;
        GicsSector?: number;
        GicsIndustryGroup?: number;
        GicsIndustry?: number;
        GicsSubIndustry?: number;
        LegalEntityIdentifier?: string;
        LeiName?: string;
        LeiEntityStatus?: string;
        LeiLegalForm?: string;
        LeiAssignedDate?: string;
        LeiLastUpdate?: string;
        LeiDisabledDate?: string;
        LeiRegistrationAddress?: string;
        LeiRecordState?: string;
        LeiMaintenanceState?: string;
        LeiNextMaintenanceDate?: string;
        DefaultSortOrder?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        RowId?: number;
        Version?: number;
        PartyRoles?: string[];
    }

    export namespace PartyRow {
        export const idProperty = 'PartyCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.Party';
        export const lookupKey = 'Data.Party';

        export function getLookup(): Q.Lookup<PartyRow> {
            return Q.getLookup<PartyRow>('Data.Party');
        }
        export const deletePermission = 'DataAdmin:Party';
        export const insertPermission = 'DataAdmin:Party';
        export const readPermission = 'Read:Party';
        export const updatePermission = 'DataAdmin:Party';

        export declare const enum Fields {
            PartyCode = "PartyCode",
            Name = "Name",
            ShortName = "ShortName",
            CountryOfDomicileCode = "CountryOfDomicileCode",
            CountryOfIncorporationCode = "CountryOfIncorporationCode",
            CountryOfRiskCode = "CountryOfRiskCode",
            PartyLegalName = "PartyLegalName",
            PartyWebAddress = "PartyWebAddress",
            PartyFaxNumber = "PartyFaxNumber",
            PartyTelNumber = "PartyTelNumber",
            PreviousPartyNames = "PreviousPartyNames",
            AlternativePartyName = "AlternativePartyName",
            IsPrivateCompany = "IsPrivateCompany",
            SpLtRating = "SpLtRating",
            MoodysLtRating = "MoodysLtRating",
            FitchLtRating = "FitchLtRating",
            InternalLtRating = "InternalLtRating",
            SpStRating = "SpStRating",
            MoodysStRating = "MoodysStRating",
            FitchStRating = "FitchStRating",
            InternalStRating = "InternalStRating",
            GicsSector = "GicsSector",
            GicsIndustryGroup = "GicsIndustryGroup",
            GicsIndustry = "GicsIndustry",
            GicsSubIndustry = "GicsSubIndustry",
            LegalEntityIdentifier = "LegalEntityIdentifier",
            LeiName = "LeiName",
            LeiEntityStatus = "LeiEntityStatus",
            LeiLegalForm = "LeiLegalForm",
            LeiAssignedDate = "LeiAssignedDate",
            LeiLastUpdate = "LeiLastUpdate",
            LeiDisabledDate = "LeiDisabledDate",
            LeiRegistrationAddress = "LeiRegistrationAddress",
            LeiRecordState = "LeiRecordState",
            LeiMaintenanceState = "LeiMaintenanceState",
            LeiNextMaintenanceDate = "LeiNextMaintenanceDate",
            DefaultSortOrder = "DefaultSortOrder",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            RowId = "RowId",
            Version = "Version",
            PartyRoles = "PartyRoles"
        }
    }
}
